<template>
  <div
    class="radio-list-element d-flex flex-row align-center justify-space-between"
    :class="{ selected: selected }"
    @click="onClick"
  >
    <div class="flex-grow-1 d-flex flex-row token-text-regular">
      <slot></slot>
    </div>
    <v-radio
      class="flex-grow-0"
      color="rgba(50, 25, 178, 1)"
      :disabled="disabled"
      :modelValue="selected"
    ></v-radio>
  </div>
</template>

<script lang="ts">
import { Vue, prop } from "vue-class-component";

class Props {
  disabled?: boolean = prop({
    required: false,
  });
  selected?: boolean = prop({
    required: false,
  });
}

export default class RadioListElement extends Vue.with(Props) {
  onClick() {
    if (this.disabled) return;
    this.$emit("select");
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/variables";

.radio-list-element {
  box-shadow: 0px 1px 4px rgba(0, 0, 58, 0.08),
    0px 1px 1px -1px rgba(0, 0, 58, 0.08),
    inset 0px -1px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  color: #00003a;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out,
    background 0.2s ease-in-out;
  border: 1px solid $color-neutral-grey-12;
  background: white;
  user-select: none;
  cursor: pointer;
  padding: 8px 12px;
  &:hover {
    border: 1px solid $color-neutral-grey-30;
  }
  &.selected {
    border: 2px solid $color-brand;
    box-shadow: 0px 0px 0px 2px rgba(50, 25, 178, 0.24);
    padding: 7px 11px; // Adjust padding to maintain overall size
  }
}
</style>
